import { CheckoutForm } from "./CheckoutForm";
import { CheckoutRedirectHandler } from "./CheckoutRedirectHandler";
import { CommunityAndPaywallPriceInfo } from "./CommunityAndPaywallPriceInfo";
import { SSOLoginPrompt } from "./SSOLoginPrompt";
import { StripeElementsManager } from "./StripeElementsManager";
import "./styles.scss";

// TODO: optimize checkout page to avoid re-rendering parts of the form that do not depend on Stripe Elements
export const CheckoutPage = () => (
  <SSOLoginPrompt>
    <CommunityAndPaywallPriceInfo />
    <StripeElementsManager>
      <CheckoutForm />
    </StripeElementsManager>
    <CheckoutRedirectHandler />
  </SSOLoginPrompt>
);
